/**
 * @param {import("../../../utils/router/Router").default} router
 */
export default function (router) {
  router.group(
    {
      path: "/alfred/bookings",
    },
    (router) => {
      router.push({
        id: "@api/booking@search",
        path: "",
      });
      router.push({
        id: "@api/booking@create",
        path: "",
      });
      router.group(
        {
          path: "/:bookingId",
        },
        (router) => {
          router.push({
            id: "@api/booking@show",
            path: "",
          });
          router.push({
            id: "@api/booking@update",
            path: "",
          });
          router.group(
            {
              path: "/action",
            },
            (router) => {
              router.push({
                id: "@api/booking@cancellation-preview",
                path: "/cancellation-preview",
              });
              router.push({
                id: "@api/booking@guest-insurance-subscription",
                path: "/guest_insurance_subscription",
              });
              router.push({
                id: "@api/booking@request-acknowledgment",
                path: "/request-acknowledgment",
              });
              router.push({
                id: "@api/booking@acknowledgment",
                path: "/acknowledgment",
              });
              router.push({
                id: "@api/booking@option",
                path: "/option",
              });
              router.push({
                id: "@api/booking@confirm",
                path: "/confirm",
              });
              router.push({
                id: "@api/booking@sold",
                path: "/sold",
              });
            },
          );
        },
      );
      router.group(
        {
          path: "/action",
        },
        (router) => {
          router.push({
            id: "@api/booking@revive",
            path: "/revive",
          });
        },
      );
      router.group(
        {
          path: "/customer-summary",
        },
        (router) => {
          router.push({
            id: "@api/booking.customer-summary@search",
            path: "",
          });

          router.group(
            {
              path: "/export",
            },
            (router) => {
              router.push({
                id: "@api/booking.customer-summary@export-pdf",
                path: "/pdf",
              });
              router.push({
                id: "@api/booking.customer-summary@export-csv",
                path: "/csv",
              });
            },
          );
        },
      );
      router.group(
        {
          path: "/export",
        },
        (router) => {
          router.push({
            id: "@api/booking@export-csv",
            path: "/csv",
          });
          router.push({
            id: "@api/booking@export-pdf",
            path: "/pdf",
          });
        },
      );
    },
  );
}
